<form [formGroup]="form" class="grid">
		<div class="form-field col-12">
			<label
				class="label"
				for="date_day"
			>
				{{ label }}
			</label>
		</div>

		<div class="form-field form-field--no-top col-4 col-tp-4 col-p-4">
			<app-select-input-indra
				#dateDay
				selectId="{{'selectDateDay'+uniqueId}}"
				placeholder="dd"
				formControlName="dateDay"
				id="date_day"
				[errorClass]="hasClassErrorDay"
				[options]="(days | async)"
				[optionsTranslated]="true"
				selectLabel="{{'bookingDetails.alt.selectDateDay' | ibeadmin: 'sync'}}"
			 ></app-select-input-indra>
		<!--	<span
				aria-live="polite"
				class="input-error"
				role="alert"
				*ngIf="form.get('dateDay').invalid && hasErrors && form.touched"
			>
				{{ errorDay }}
			</span>-->
		</div>
		<div class="form-field form-field--no-top col-4 col-tp-4 col-p-4">
			<app-select-input-indra
				#dateMonth
				selectId="{{'selectdateMonth'+uniqueId}}"
				placeholder="mm"
				formControlName="dateMonth"
				id="date_month"
				[errorClass]="hasClassErrorMonth"
				[options]="months"
				[optionsTranslated]="true"
				selectLabel="{{'bookingDetails.alt.selectDateMonth' | ibeadmin: 'sync'}}"
			></app-select-input-indra>
			<!--<span
				aria-live="polite"
				class="input-error"
				role="alert"
				*ngIf="form.get('dateMonth').invalid && hasErrors && form.touched">
				{{ errorMonth }}
			</span>-->
		</div>
		<div class="form-field form-field--no-top col-4 col-tp-4 col-p-4">
			<app-select-input-indra
				#dateYear
				selectId="{{'selectdateYear'+uniqueId}}"
				placeholder="yyyy"
				formControlName="dateYear"
				id="date_year"
				[errorClass]="hasClassErrorYear"
				[options]="years"
				[optionsTranslated]="true"
				selectLabel="{{'bookingDetails.alt.selectDateYear' | ibeadmin: 'sync'}}"
			></app-select-input-indra>
			<!--<span
				aria-live="polite"
				class="input-error"
				role="alert"
				*ngIf="form.get('dateYear').invalid && hasErrors && form.touched">{{ errorYear }}
			</span>-->
		</div>
</form>
